SA.queryParameters = (() => {
    var params = Ext.Object.fromQueryString(location.search),
        has = property => Reflect.has(params, property);

    return Object.assign(params, {has});
})();